import React from "react";
import { ReactComponent as FacebookLogo } from "../../assets/Facebook.svg";
import { ReactComponent as InstagramLogo } from "../../assets/instagram.svg";
import { ReactComponent as PinterestLogo } from "../../assets/pinterest.svg";
import { ReactComponent as YouTubeLogo } from "../../assets/youtube.svg";
import { ReactComponent as LinkedinLogo } from "../../assets/linkedin.svg";
import style from "./style.module.scss";
import clsx from "clsx";

export function Socials({ socials, className = null }) {
  const hasSocials =
    socials?.youtubeUrl ||
    socials?.instagramUrl ||
    socials?.pinterestUrl ||
    socials?.facebookUrl ||
    socials?.linkedinUrl;

  return !hasSocials ? null : (
    <div className={clsx(style.socials, className)}>
      {socials?.instagramUrl && (
        <a href={socials.instagramUrl} target="_blank" rel="noreferrer">
          <InstagramLogo />
        </a>
      )}
      {socials?.facebookUrl && (
        <a href={socials.facebookUrl} target="_blank" rel="noreferrer">
          <FacebookLogo />
        </a>
      )}
      {socials?.pinterestUrl && (
        <a href={socials.pinterestUrl} target="_blank" rel="noreferrer">
          <PinterestLogo />
        </a>
      )}
      {socials?.youtubeUrl && (
        <a href={socials.youtubeUrl} target="_blank" rel="noreferrer">
          <YouTubeLogo />
        </a>
      )}
      {socials?.linkedinUrl && (
        <a href={socials.linkedinUrl} target="_blank" rel="noreferrer">
          <LinkedinLogo />
        </a>
      )}
    </div>
  );
}

export default Socials;
